import { Injectable } from '@angular/core';

export interface MainPageSettings {
  showRecentNotifications: boolean;
  showQuickActions: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  private readonly STORAGE_KEY = 'mainPageSettings';
  
  private defaultSettings: MainPageSettings = {
    showRecentNotifications: false,
    showQuickActions: false
  };

  getSettings(): MainPageSettings {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    if (stored) {
      const parsedSettings = JSON.parse(stored);
      return { ...this.defaultSettings, ...parsedSettings };
    }
    return { ...this.defaultSettings };
  }

  saveSettings(settings: MainPageSettings): void {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(settings));
  }

  updateSetting(key: keyof MainPageSettings, value: boolean): void {
    const currentSettings = this.getSettings();
    currentSettings[key] = value;
    this.saveSettings(currentSettings);
  }
}